import React, { Component } from 'react';
import { withStyles  } from '@mui/styles';
import { isEmpty } from 'lodash';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import moment from 'moment';
import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Drawer from '@mui/material/Drawer';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';
import LinearProgress from '@mui/material/LinearProgress';
import { Delete, AttachFile, CloudUpload, ContentCopy } from '@mui/icons-material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {
  uploadAttachment,
  selectAttachment,
  listAttachments,
  deleteAttachment
} from "../actions/orderActions";
import {toast} from "react-toastify";

const styles = theme => ({
  root: {
    width: window.innerWidth - 200,
    padding: 30
  },
  head: {
    display: 'flex',
    flexFlow: 'wrap'
  },
  fullWidth: {
    width: '100%'
  },
  title: {
    flex: 1
  },
  field: {
    width: '100%',
    marginTop: 5,
    padding: 10,
    background: theme.palette.primary.light
  },
  value: {
    width: '100%',
    marginTop: 5,
    padding: 10,
    minHeight: 44
  },
  fieldFont: {
    color: theme.palette.primary.dark,
    fontWeight: 700
  },
  valueFont: {
    fontWeight: 400
  },
  card: {
    minWidth: window.innerWidth - 200,
    position: 'relative'
  },
  cardWrapper: {
    position: 'absolute',
    height:  window.innerHeight,
    top: 'calc(50% - 6%)',
    left: 'calc(50% - 6%)',
    padding: 30
  }
});

class AttachmentsView extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  componentDidMount() {
    if (isEmpty(this.props.attachments) || this.props.attachments.orderId !== this.props.order.id) {
      const { dispatch, order } = this.props;
      dispatch(listAttachments(order.id))
    } 
    if (this.props.downloadAttachmentId && this.props.downloadAttachmentName) {
      this.setState({
        dialogTitle: "Download Attachment.",
        dialogText: `You accessed a direct link to a file attached to this IO.\n The file name is "${this.props.downloadAttachmentName}".\nClick "Download" if you want to download.`,
        dialogOkText: "Download File",
        dialogHref:`/api/ios/${this.props.ioid}/attachments/${this.props.downloadAttachmentId}`,
        dialogTarget: "_blank",
        onDialogOK: async () => {
          this.hideConfirmationDialog();
        }
      });
    }
  }

  // replace object with string and format date before applying font
  fixValue = thing => {
    let res;
    if (typeof thing === 'object') {
      res = JSON.stringify(thing).replace(/,/g, ', ');
    } else if (moment(thing, moment.ISO_8601, true).isValid()) {
      res = moment(thing).format('MMM D, YYYY');
    } else {
      res = thing;
    }
    return this.makeNice(res);
  };

  makeNice = text => {
    const { classes } = this.props;
    return (
      <Typography variant="subtitle1" className={classes.valueFont}>
        {text}
      </Typography>
    )
  };

  makeTitle = text => {
    const { classes } = this.props;
    return (
      <Typography variant="h6" className={classes.title}>
        {text}
      </Typography>
    )
  };

  onFileChanged = (e) => {
    const { dispatch } = this.props;
    const target = e.target;
    if (target.files){
      let files = [];
      for(let i=0; i<target.files.length; i++) {
        files.push(target.files[i]);
      }
      const names = files.map(f => f.name)
      dispatch(selectAttachment({
        isNew: true,
        names,
        files
      }))
    }
  }

  onNameChanged = (e) => {
    const { dispatch, attachment } = this.props;
    if (!attachment || !attachment.files || attachment.files.length !== 1)
      return;
    dispatch(selectAttachment({
      ...attachment,
      names: [e.target.value]
    }))
  }
  
  onUploadFile = async () => {
    const { dispatch, order, attachment } = this.props;
    for(let i=0; i < attachment.files.length; i++) {
      const file = attachment.files[i];
      const name = attachment.names[i];
      await dispatch(uploadAttachment(order.id, file, name));
    }
    await dispatch(listAttachments(order.id));
  }

  onDeleteAttachment = (attachment) => async () => {
    const { dispatch } = this.props;
    this.setState({
      ...this.state,
      dialogTitle: "Delete Attachment",
      dialogText: `The attachment ${attachment.name} will be deleted`,
      onDialogOK: async () => {
        this.hideConfirmationDialog();
        await dispatch(deleteAttachment(attachment.IoId, attachment.id))
        await dispatch(listAttachments(attachment.IoId));
      }
    });
  }
  
  static attachmentOpenURL = (ioId, attachmentId) => `${window.location.protocol}//${window.location.host}/ios/${ioId}#attachment-${attachmentId}`;
  
  onCopyAttachmentLink = (ioID, attachmentId, attachmentName) => async () => {
    const url = `${AttachmentsView.attachmentOpenURL(ioID, attachmentId)}-${escape(attachmentName)}`;
    try {
      navigator.clipboard.writeText(url);
      const message = 'A direct link to the attached file was copied to the clipboard';
      toast.success(message, { theme: 'colored', toastId: message });
    } catch(e) {
      const message = `Error copying link to the clipboard: ${e} `;
      toast.success(message, { theme: 'colored', toastId: message });
    }
  }
  
  hideConfirmationDialog = () => {
    this.setState({
      ...this.state,
      dialogText: null,
      onDialogOK: null
    });
  }
 
  fmtSize = (size)  => {
    if (size >= 1024*1024) return `${size/(Math.round(1024*1024))} MB`;
    if (size >= 1024) return `${Math.round(size/1024)} KB`;
    return String(size);
  }
  
  render() {
    const {      
      open,      
      classes,
      order,
      onClose, 
      isFetchingAttachments,
      isUploadingAttachment,
      attachment,
      attachments,
      isReadOnly
    } = this.props;

    const { 
      dialogTitle,
      dialogText,
      dialogOkText,
      dialogHref,
      dialogTarget,
      onDialogOK,
    } = this.state;
   
    return (
      <div>
        <Drawer
          anchor="right"
          open={open}
          onClose={onClose}
        >
            <div className={classes.root}>
              {dialogText &&  <DialogBox 
                  title={dialogTitle}
                  text={dialogText} 
                  onOK={onDialogOK} 
                  onCancel={this.hideConfirmationDialog} 
                  okText={dialogOkText}
                  href={dialogHref}
                  target={dialogTarget}
              />}
              <div className={classes.head}>
                {this.makeTitle(`File Attachments for ${order.id}`)}
                <div>
                  <IconButton onClick={onClose} size="large">
                    <Close />
                  </IconButton>
                </div>
              </div>

            <div>
            {!isFetchingAttachments && !isUploadingAttachment && !isReadOnly &&
              <Box mt={1} pb={2}>
              <Grid container spacing={1}>
                <Grid item xs={1}>
                <Button   
                    component="label"
                    className={classes.button}
                    color="primary"
                    variant="contained"
                    >
                    <AttachFile  />
                    Select
                    <input hidden type="file" onChange={this.onFileChanged}  multiple />
                </Button>
                </Grid>
                <Grid item xs={10}>
                    {attachment && attachment.files && <Box>
                  <TextField
                    variant="standard"
                    fullWidth
                    placeholder="Name"
                    value={((attachment ||{}).names || []).join(', ')}
                    isReadOnly={attachment && attachment.files.length > 1}
                    onChange={this.onNameChanged} />
                </Box>}
                </Grid>
                <Grid item xs={1}>
                  {attachment && attachment.files && <Button
                    className={classes.button}
                    onClick={this.onUploadFile}
                    color="primary"
                    variant="contained">
                      <CloudUpload  />
                      Upload
                  </Button>}
                </Grid>
              </Grid>
              </Box>
            }
          </div> 
          <Divider />
          {(isFetchingAttachments || isUploadingAttachment) && <LinearProgress /> }
          {!isFetchingAttachments &&
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 250 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>Name</TableCell>
                    <TableCell></TableCell>
                    <TableCell align="right">Size</TableCell>
                    <TableCell>User</TableCell>
                    <TableCell>Date</TableCell>
                    <TableCell></TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    {(attachments || []).map((a, i) => (
                      <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                      <TableCell component="th" scope="row">
                        <a target="_blank" rel="noopener noreferrer" href={`/api/ios/${a.IoId}/attachments/${a.id}`}>
                          {a.name}
                        </a>
                      </TableCell>
                      <TableCell>
                          <Button onClick={this.onCopyAttachmentLink(a.IoId, a.id, a.name)} title="Copy direct link to this file to the clipboard">
                            <ContentCopy/>
                          </Button>
                      </TableCell>
                      <TableCell align="right">{this.fmtSize(a.size)}</TableCell>
                      <TableCell >{a.user}</TableCell>
                      <TableCell >{moment(a.createdAt).format('MMM D, YYYY HH:MM')}</TableCell>
                      {!isReadOnly &&
                      <TableCell align="right">
                        <Button onClick={this.onDeleteAttachment(a)} title="Delete attachment">
                          <Delete  title="Delete attachment"/>
                        </Button>
                      </TableCell>
                      }                      
                      </TableRow>
                    ))}
      
                </TableBody>
              </Table>
            </TableContainer>
          }
          {(!attachments || !attachments.length) &&
              <Typography variant="subtitle1">No file attachments for this order</Typography>
          }
          </div>
        </Drawer>
      </div>
    );
  }
}

function DialogBox(props) {
  const { title, text, onOK, href, target, okText, onCancel } = props;
  return <Dialog open={true}>
    <DialogTitle id="alert-dialog-title" >
        {title}
    </DialogTitle>
    <DialogContent sx={{ minWidth: 300, minHeight: 50 }}>
      <DialogContentText id="alert-dialog-description">
        <div>{text}</div>
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onOK} href={href} target={target}>
        {okText || "OK"}
      </Button>
      <Button onClick={onCancel} autoFocus>
        Cancel
      </Button>
    </DialogActions>
  </Dialog>
  ;
}


AttachmentsView.defaultProps = {
  attachment: null,
  attachments: null
};

export default withStyles(styles)(AttachmentsView);
